import type { CommsCampaignMessage } from './interfaces';

// Snapshot of ss_5d984be8f6031f756d459b76c070_default, updated 2026-09-18T16:56:15.923Z.
// Keep source wording and scheduling; each destination campaign receives new message ids.
export const SELF_SERVICE_COMMS_CAMPAIGN_TEMPLATE: ReadonlyArray<Omit<CommsCampaignMessage, 'id'>> = [
    {
        "amount": 1,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "email"
        ],
        "text": "<span><p><span><font size=\"4\"><b>Feel more confident helping your child</b></font></span></p><p><span>We’d love you to try SuperPenguin. It helps parents and carers feel more confident about supporting their child’s speech and language.</span></p><p><span>You use the app to learn, then use what you learn with your child. It’s support for you, with your child at the heart of it.</span></p><p><span>Get started:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></p><p>$PROVIDER_NAME</p></span><br>"
    },
    {
        "amount": 3,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "email"
        ],
        "text": "<span><p><span><font size=\"4\"><b>Put the kettle on. This one’s for you.</b></font></span></p><p><span>Make a cup of tea and take five minutes for yourself. Listen to SuperPenguin and learn more about helping your child.</span></p><p><span>A little time to learn can help you feel more sure about what to do.</span></p><p><span>Take a look:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></p><p><span>$PROVIDER_NAME</span></p></span><br>"
    },
    {
        "amount": 5,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "email"
        ],
        "text": "<span><p><span><b><font size=\"4\">Good to know who’s behind the advice</font></b></span></p><p><span>Speech and language therapists write SuperPenguin’s content. NHS speech and language therapists helped the team make the app.</span></p><p><span>Families also share their views to help make it better.</span></p><p><span>We’re sharing it so you have help you can trust.</span></p><p><span>Take a look:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></p><p><span>$PROVIDER_NAME</span></p></span>"
    },
    {
        "amount": 10,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "email"
        ],
        "text": "<span><p><span><b><font size=\"4\">Let’s get you started</font></b></span></p><p><span>Not sure where to begin? Answer a few short questions in SuperPenguin. The app will suggest topics that may help your family.</span></p><p><span>You don’t have to work it all out before you start.</span></p><p><span>Give it a go:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></p><p><span>$PROVIDER_NAME</span></p></span><br>"
    },
    {
        "amount": 30,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "email"
        ],
        "text": "<span><p><span><b><font size=\"4\">A little support for you, too</font></b></span></p><p><span>You want to help your child, and we want you to feel supported too.</span></p><p><span>SuperPenguin is a place to learn more about speech and language and build your confidence. Give it a try when you have a quiet moment to yourself.</span></p><p><span>Get started:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></p><p><span>$PROVIDER_NAME</span></p></span><br>"
    },
    {
        "amount": 3,
        "unit": "days",
        "since": "user_signed_up",
        "stages": [
            "signed_in_successfully",
            "completed_onboarding",
            "first_used_app"
        ],
        "channels": [
            "email"
        ],
        "text": "<span><p><span><b><font size=\"4\">From breakfast to bedtime</font></b></span></p><p><span>Getting ready, sharing a meal, playing together. SuperPenguin helps you learn how to support your child in these moments.</span></p><p><span>It’s about feeling more confident in the time you already share.</span></p><p><span>Open SuperPenguin:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></p><p><span>$PROVIDER_NAME</span></p></span><br>"
    },
    {
        "amount": 5,
        "unit": "days",
        "since": "user_signed_up",
        "stages": [
            "signed_in_successfully",
            "completed_onboarding",
            "first_used_app"
        ],
        "channels": [
            "email"
        ],
        "text": "<span><p><span><b><font size=\"4\">Am I doing this right?</font></b></span></p><p><span>If you’ve wondered this, give yourself a little help.</span></p><p><span>SuperPenguin helps you learn more about your child’s speech and language. With advice from therapists, you can feel clearer about what to do and why.</span></p><p><span>Open SuperPenguin:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></p><p><span>$PROVIDER_NAME</span></p></span>"
    },
    {
        "amount": 10,
        "unit": "days",
        "since": "user_signed_up",
        "stages": [
            "signed_in_successfully",
            "completed_onboarding",
            "first_used_app"
        ],
        "channels": [
            "email"
        ],
        "text": "<b><font size=\"4\">Some things are worth another listen\n</font></b>\nSome things make more sense the second time you hear them.\n\nIf you’d like to understand something better, read or listen again in SuperPenguin. Take your time. There’s no rush.\n\nOpen SuperPenguin: https://app.superpenguin.com\n\n$PROVIDER_NAME"
    },
    {
        "amount": 30,
        "unit": "days",
        "since": "user_signed_up",
        "stages": [
            "signed_in_successfully",
            "completed_onboarding",
            "first_used_app"
        ],
        "channels": [
            "email"
        ],
        "text": "<span><p><span><b><font size=\"4\">Here for you as your child grows</font></b></span></p><p><span>New routines can bring new questions. SuperPenguin is here to help you keep learning as your child grows.</span></p><p><span>Find a moment this week to spend with the app. There’s support here for you, too.</span></p><p><span>Open SuperPenguin:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></p><p><span>$PROVIDER_NAME</span></p></span>"
    },
    {
        "amount": 1,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "sms"
        ],
        "text": "<span><span>From $PROVIDER_NAME: SuperPenguin is made for parents and carers. Learn about your child's speech and language and feel more confident about how to help:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></span>"
    },
    {
        "amount": 3,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "sms"
        ],
        "text": "<span><span>From $PROVIDER_NAME: Put the kettle on. This one's for you. Spend five minutes with SuperPenguin and learn more about supporting your child:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></span>"
    },
    {
        "amount": 5,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "sms"
        ],
        "text": "<span><span>From </span></span><span><span>$PROVIDER_NAME</span></span><span><span>: SuperPenguin's advice comes from speech and language therapists. Families also help make the app better by sharing their views. Take a look:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></span>"
    },
    {
        "amount": 10,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "sms"
        ],
        "text": "<span><span>From $PROVIDER_NAME: Let's get you started. Answer a few short questions in SuperPenguin to find a starting point for your family:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></span>"
    },
    {
        "amount": 30,
        "unit": "days",
        "since": "referral_account_created",
        "stages": [
            "referral_created_not_signed_in"
        ],
        "channels": [
            "sms"
        ],
        "text": "<span><span>From $PROVIDER_NAME: You want to help your child. We're here to support you, too. Try SuperPenguin when you have a quiet moment for yourself:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></span>"
    },
    {
        "amount": 3,
        "unit": "days",
        "since": "user_signed_up",
        "stages": [
            "signed_in_successfully",
            "completed_onboarding",
            "first_used_app"
        ],
        "channels": [
            "sms"
        ],
        "text": "<span><span>From $PROVIDER_NAME: From breakfast to bedtime, there are lots of moments together. Learn with SuperPenguin and feel more confident helping your child through the day:</span><a href=\"https://app.superpenguin.com/\" target=\"_blank\" rel=\"noreferrer\"><span> </span><span>https://app.superpenguin.com</span></a></span>"
    },
    {
        "amount": 5,
        "unit": "days",
        "since": "user_signed_up",
        "stages": [
            "first_used_app",
            "completed_onboarding",
            "signed_in_successfully"
        ],
        "channels": [
            "sms"
        ],
        "text": "From $PROVIDER_NAME: Ever wondered, &quot;Am I doing this right?&quot; Learn with SuperPenguin and feel more sure about the support you give your child: https://app.superpenguin.com"
    },
    {
        "amount": 10,
        "unit": "days",
        "since": "user_signed_up",
        "stages": [
            "first_used_app",
            "completed_onboarding",
            "signed_in_successfully"
        ],
        "channels": [
            "sms"
        ],
        "text": "From $PROVIDER_NAME: Some things make more sense the second time. Read or listen again in SuperPenguin and give yourself time to learn. There's no rush: https://app.superpenguin.com"
    },
    {
        "amount": 30,
        "unit": "days",
        "since": "user_signed_up",
        "stages": [
            "first_used_app",
            "completed_onboarding",
            "signed_in_successfully"
        ],
        "channels": [
            "sms"
        ],
        "text": "From $PROVIDER_NAME: A new routine or a new question? Make a little time for SuperPenguin this week. Keep learning and build your confidence in helping your child: https://app.superpenguin.com"
    }
];
